import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import moment from 'moment';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ReactComponent as CloseButtonSvg } from 'assets/images/location/close-button-svg.svg';

import AppInputValidation from 'components/App/InputValidation';
import Button from 'components/App/Button';

import { parseCurrency } from 'utils';

import styles from './ModalEditQuantityRoom.module.scss';

function ModalEditQuantityRoom(props) {
  const {
    isOpen,
    data,
    onToggleModal,
    actionUpdateLocation,
    roomStatusList,
    place,
    dayStartFormat,
    dayEndFormat,
  } = props;

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      availableRooms: data.availableRooms ?? '',
    },

    validationSchema: Yup.object({
      availableRooms: Yup.number()
        .transform((value, originalValue) => (
          originalValue === '' || originalValue === null || originalValue === undefined
            ? undefined
            : value
        ))
        .required('Vui lòng nhập số lượng')
        .min(0, 'Số lượng không hợp lệ'),
    }),

    onSubmit: (values) => {
      const dataUpdate = {
        roomInfo: {
          id: place,
          roomId: data.room,
          roomStatusId: data._id,
        },
        newRoomStatus: {
          status: data.roomStatus === 'FULL' ? 'AVAILABLE' : data.roomStatus,
          availableRooms: values.availableRooms,
          prices: (data.prices || []).map((item) => ({
            price: parseCurrency(item.price),
            priceType: item.priceType,
          })),
        },
        filter: {
          start: dayStartFormat,
          end: dayEndFormat,
          place,
        },
        callback: onToggleModal,
      };
      actionUpdateLocation(dataUpdate);
    },
  });

  const roomInfo = roomStatusList.find((item) => item._id === data.room);

  const CloseButton = useMemo(
    () => (
      <button
        className={styles.ButtonClose}
        onClick={onToggleModal}
        type="button"
      >
        <CloseButtonSvg />
      </button>
    ),
    [onToggleModal],
  );

  if (!roomInfo) {
    return null;
  }

  return (
    <div className={styles.Component}>
      <Modal
        fade
        size="lg"
        isOpen={isOpen}
        toggle={onToggleModal}
        className={styles.Modal}
      >
        <div className={styles.ModalHeaderWrapper}>
          <h2 className={styles.ModalHeaderTitle}>Cập nhật số lượng</h2>
          <ModalHeader
            toggle={onToggleModal}
            close={CloseButton}
            className={styles.ModalHeader}
          />
        </div>
        <ModalBody className={styles.ModalBody}>
          <div className="ServiceWrapper">
            <h3 className="ServiceWrapper__Title">{`Cập nhật nhanh số lượng phòng ${roomInfo.name.toUpperCase()} ngày ${moment(data.statusDate).format('DD-MM-YYYY')}`}</h3>

            <div className="ModalEditRoom__FormField">
              <AppInputValidation
                name="availableRooms"
                id="availableRooms"
                type="number"
                validation={validation}
                placeholder="Nhập số phòng"
                wrapperClassName="Input__Wrapper"
                inputClassName="Input__Number"
                value={validation.values.availableRooms}
              />
            </div>
          </div>
        </ModalBody>

        <ModalFooter className={styles.ModalFooter}>
          <div className="FooterButton">
            <div className="d-flex m-0 gap-2">
              <Button classes="Button Button__Cancel" onClick={onToggleModal}>
                Hủy
              </Button>

              <Button
                classes=" Button Button__Submit"
                onClick={validation.handleSubmit}
              >
                Xác nhận
              </Button>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
}

ModalEditQuantityRoom.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  place: PropTypes.string,
  dayStartFormat: PropTypes.string,
  dayEndFormat: PropTypes.string,

  onToggleModal: PropTypes.func.isRequired,
  actionUpdateLocation: PropTypes.func.isRequired,

  roomStatusList: PropTypes.instanceOf(Array),
  data: PropTypes.instanceOf(Object),
};

ModalEditQuantityRoom.defaultProps = {
  data: {},
  roomStatusList: [],
  place: '',
  dayStartFormat: '',
  dayEndFormat: '',
};

export default memo(ModalEditQuantityRoom);
